import { useState } from 'react';
import { RolesApi } from '@/api/clients/roles/roles.api';

export const useUpdateRole = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const updateRole = async (roleId, roleData) => {
    setLoading(true);
    setError(null);

    try {
      await RolesApi.updateRole(roleId, roleData);
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || 'Failed to update role';
      setError(errorMessage);
      console.error('Error updating role:', err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const clearError = () => {
    setError(null);
  };

  return {
    updateRole,
    loading,
    error,
    clearError,
  };
};
